import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import ImageInfoMenu from '../../../global/ImageInfoMenu';
import { isVideo } from '../../../utils';
import CustomVideo from '../../../global/ui/CustomVideo';

const ImageHeroSwiper = ({ thumbsSwiper, setMainSwiper, setActiveIndex, filteredPhotos, setShowInfoMenu, showInfoMenu, handleDownload, onInfo, activeIndex, total, handleDelete, mainSwiper, onThumbnail, locationData }: any) => {

    const getName = (url: any) => {
        const fileName = new URL(url)?.pathname?.split("/")?.pop();
        return fileName
    }
    return (
        <div className="lg-main-wrap">
            <Swiper
                modules={[Navigation, Thumbs]}
                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                onSwiper={setMainSwiper}
                onSlideChange={s => {
                    setActiveIndex(s.activeIndex)
                    // mainSwiper?.updateAutoHeight();
                }}
                className="lg-main-swiper"
                navigation={{
                    prevEl: '.lg-nav-prev',
                    nextEl: '.lg-nav-next',
                }}
            // autoHeight={true}
            >
                {filteredPhotos.map((photo: any) => (
                    <SwiperSlide key={photo?.id}>
                        <div className="lg-slide">
                            {isVideo(photo) ? (
                                <CustomVideo
                                    className="lg-slide__img"
                                    src={photo?.image}
                                    controls={false}
                                />
                            ) : (
                                <img src={photo?.image} alt={photo?.id} className="lg-slide__img" />
                            )}
                            <div className="lg-slide__overlay" />

                            {/* Filename top-left */}
                            {/* <span className="lg-slide__filename">{getName(photo?.image)}</span> */}

                            {/* Info button top-right */}
                            {locationData?.role != 'V' &&
                                <div className="lg-slide__info-wrap">
                                    <button
                                        className="lg-slide__info-btn"
                                        onClick={e => {
                                            e.stopPropagation();
                                            setShowInfoMenu((p: any) => !p);
                                        }}
                                        aria-label="Image info"
                                    >
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="12" y1="8" x2="12" y2="8" strokeWidth="2.5" />
                                            <line x1="12" y1="12" x2="12" y2="16" />
                                        </svg>
                                    </button>

                                    {showInfoMenu && (
                                        <ImageInfoMenu
                                            onClose={() => setShowInfoMenu(false)}
                                            onDownload={() => {
                                                setShowInfoMenu(false)
                                                handleDownload?.(photo)
                                            }}
                                            onInfo={() => {
                                                setShowInfoMenu(false);
                                                onInfo(photo);
                                            }}
                                            onDelete={() => {
                                                setShowInfoMenu(false);
                                                handleDelete(photo)
                                            }}
                                            showthumbnail
                                            onThumbnail={(type) => {
                                                setShowInfoMenu(false);
                                                onThumbnail(photo, type)
                                            }}
                                            showLocationThumbnail
                                        />
                                    )}
                                </div>
                            }

                            {/* Counter bottom-center */}
                            <div className="lg-slide__counter">
                                {activeIndex + 1} of {total}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Custom nav arrows */}
            <button className="lg-nav-btn lg-nav-prev" aria-label="Previous">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
                    <polyline points="15 18 9 12 15 6" />
                </svg>
            </button>
            <button className="lg-nav-btn lg-nav-next" aria-label="Next">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
            </button>
        </div>
    )
}

export default ImageHeroSwiper